import handler from 'api/handler'

const prefix = '/admin/pushNotification'

const methods = {
  send: args => handler({ method: 'post', url: prefix + '/send', args }),
  sendToUser: args => handler({ method: 'post', url: prefix + '/sendToUser', args }),
  broadcast: args => handler({ method: 'post', url: prefix + '/broadcast', args })
}

export default methods

